/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FacebookOptions from 'app/components/EditorComponents/SocialPanels/FacebookOptions.jsx';
import FeedOptions from 'app/components/EditorComponents/SocialPanels/FeedOptions.jsx';
import GMBOptions from 'app/components/EditorComponents/SocialPanels/GMBOptions.jsx';
import InstagramBusinessOptions from 'app/components/EditorComponents/SocialPanels/InstagramBusinessOptions.jsx';
import LinkedInOptions from 'app/components/EditorComponents/SocialPanels/LinkedInOptions.jsx';
import PinterestOptions from 'app/components/EditorComponents/SocialPanels/PinterestOptions.jsx';
import StockTwitsOptions from 'app/components/EditorComponents/SocialPanels/StockTwitsOptions.jsx';
import TumblrOptions from 'app/components/EditorComponents/SocialPanels/TumblrOptions.jsx';
import BloggerOptions from 'app/components/EditorComponents/SocialPanels/BloggerOptions.jsx';
import RedditOptions from 'app/components/EditorComponents/SocialPanels/RedditOptions.jsx';
import WordpressOutputOptions from 'app/components/EditorComponents/SocialPanels/WordpressOutputOptions.jsx';
import TwitterOptions from 'app/components/EditorComponents/SocialPanels/TwitterOptions.jsx';
import SlackOptions from 'app/components/EditorComponents/SocialPanels/SlackOptions.jsx';
import DiscordOptions from 'app/components/EditorComponents/SocialPanels/DiscordOptions.jsx';
import MastodonOptions from 'app/components/EditorComponents/SocialPanels/MastodonOptions.jsx';
import TikTokOptions from 'app/components/EditorComponents/SocialPanels/TikTokOptions.jsx';
import BlueskyOptions from 'app/components/EditorComponents/SocialPanels/BlueskyOptions.jsx';
import NextdoorOptions from 'app/components/EditorComponents/SocialPanels/NextdoorOptions.jsx';
import YouTubeOptions from 'app/components/EditorComponents/SocialPanels/YouTubeOptions.jsx';
import ThreadsOptions from 'app/components/EditorComponents/SocialPanels/ThreadsOptions.jsx';
import SnapchatOptions from 'app/components/EditorComponents/SocialPanels/SnapchatOptions.jsx';
import HelperPanel from 'app/components/EditorComponents/SocialPanels/HelperPanel.jsx';
import Loading from 'app/components/common/Loading.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class SocialEditorPanel extends React.Component {
    constructor(props) {
        super(props);

        this.getOptionsPanel = this.getOptionsPanel.bind(this);

    }

    getOptionsPanel(type) {
        let constants = this.props.app.config.constants;

        switch(parseInt(type, 10)) {
            case constants.POST_SVC_TWITTER:
                return TwitterOptions;

            case constants.POST_SVC_FACEBOOK:
                return FacebookOptions;

            case constants.POST_SVC_GMYBUSINESS:
                return GMBOptions;

            case constants.POST_SVC_INSTAGRAM_BUSINESS:
                return InstagramBusinessOptions;

            case constants.POST_SVC_LINKEDIN:
                return LinkedInOptions;

            case constants.POST_SVC_TUMBLR:
                return TumblrOptions;

            case constants.POST_SVC_BLOGGER:
                return BloggerOptions;

            case constants.POST_SVC_REDDIT:
                return RedditOptions;

            case constants.POST_SVC_WORDPRESS:
                return WordpressOutputOptions;

            case constants.POST_SVC_FEED:
                return FeedOptions;

            case constants.POST_SVC_STOCKTWITS:
                return StockTwitsOptions;

            case constants.POST_SVC_PINTEREST:
                return PinterestOptions;

            case constants.POST_SVC_SLACK:
                return SlackOptions;

            case constants.POST_SVC_DISCORD:
                return DiscordOptions;

            case constants.POST_SVC_MASTODON:
                return MastodonOptions;

            case constants.POST_SVC_TIKTOK:
                return TikTokOptions;

            case constants.POST_SVC_BLUESKY:
                return BlueskyOptions;

            case constants.POST_SVC_NEXTDOOR:
                return NextdoorOptions;

            case constants.POST_SVC_YOUTUBE:
                return YouTubeOptions;

            case constants.POST_SVC_THREADS:
                return ThreadsOptions;

            case constants.POST_SVC_SNAPCHAT:
                return SnapchatOptions;

            default:
                return null;
        }

    }

    render() {
        var Panel = this.getOptionsPanel(this.props.social.psID),
            EditorPanel = null,
            constants = this.props.app.config.constants,
            socialOverrides = null;

        if (this.props.app.configLoaded === false ||
            this.props.userLoaded === false ||
            this.props.app.loading.social ||
            this.props.app.loading.output) {
            return (
                <Loading />
            );
        }

        if (this.props.activePanel === 'links') {
            EditorPanel = (
                <HelperPanel
                    {...this.props}
                    social={this.props.social}
                    output={this.props.output}
                    changeHandler={this.props.changeHandler}
                    errors={this.props.errors}
                    fieldMapping={this.props.fieldMapping}
                    errorMapping={this.props.errorMapping} />
            );
        } else {
            let hasInputOverrides = false,
                overrideTypes = [
                    constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
                    constants.INPUT_TYPE_FACEBOOK_PAGE
                ];

            if (this.props.route !== undefined) {
                this.props.route.inputs.map((input) => {
                    if (overrideTypes.indexOf(input.type) !== -1) {
                        hasInputOverrides = true;
                    }
                    if (input.socialOverrides !== undefined) {
                        socialOverrides = input.socialOverrides;
                    }
                });
            }

            if (Panel !== null) {
                EditorPanel = (
                    <Panel
                        {...this.props}
                        social={this.props.social}
                        output={this.props.output}
                        changeHandler={this.props.changeHandler}
                        activePanel={this.props.activePanel}
                        deleteHandler={this.props.deleteHandler}
                        deleteConfirmation={this.props.deleteConfirmation}
                        errors={this.props.errors}
                        fieldMapping={this.props.fieldMapping}
                        errorMapping={this.props.errorMapping}
                        hasInputOverrides={hasInputOverrides}
                        socialOverrides={socialOverrides} />
                );
            }
        }



        return (
            <div>{EditorPanel}</div>
        );
    }

}

SocialEditorPanel.propTypes = {
    social: PropTypes.object,
    output: PropTypes.object,
    changeHandler: PropTypes.func,
    activePanel: PropTypes.string,
    deleteHandler: PropTypes.func,
    deleteConfirmation: PropTypes.bool,
    errors: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    fieldMapping: PropTypes.string,
    errorMapping: PropTypes.string,
    isEditable: PropTypes.bool
};

SocialEditorPanel.defaultProps = {
    social: {},
    output: {},
    changeHandler: null,
    activePanel: '',
    deleteHandler: null,
    deleteConfirmation: false,
    errors: null,
    fieldMapping: '',
    errorMapping: '',
    isEditable: true
};

export default ComponentWithContext(SocialEditorPanel);
